var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlayPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8929 10.5686L2.70209 0.0921828C2.54128 -0.0183437 2.3328 -0.0298678 2.16098 0.0597058C1.98864 0.150327 1.88074 0.328427 1.88074 0.523288V21.4762C1.88074 21.671 1.98864 21.8497 2.16098 21.9403C2.23746 21.9801 2.32127 22 2.40456 22C2.5088 22 2.61252 21.9686 2.70209 21.9073L17.8929 11.4308C18.0349 11.3329 18.1192 11.1721 18.1192 10.9997C18.1192 10.8274 18.0344 10.6666 17.8929 10.5686Z",
    fill: "#ff6eb4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayPink);
export default __webpack_public_path__ + "static/media/icPlayPink.7b296dbd09020663670141811c8306ee.svg";
export { ForwardRef as ReactComponent };